
import React from 'react';
import { Button } from "@/components/ui/button";
import { Heart, X } from 'lucide-react';
import { motion } from 'framer-motion';
import { SwipeActionsProps } from '@/types/job';

export const SwipeActions: React.FC<SwipeActionsProps> = ({ 
  onSwipeLeft, 
  onSwipeRight,
  disabled
}) => {
  return (
    <div className="flex justify-center gap-4">
      <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
        <Button
          variant="outline"
          size="lg"
          className="h-14 w-14 rounded-full border-2 border-red-300 hover:border-red-400 hover:bg-red-50"
          onClick={onSwipeLeft}
          disabled={disabled}
        >
          <X className="h-7 w-7 text-red-500" />
        </Button>
      </motion.div>
      
      <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
        <Button
          variant="outline"
          size="lg"
          className="h-14 w-14 rounded-full border-2 border-green-300 hover:border-green-400 hover:bg-green-50"
          onClick={onSwipeRight}
          disabled={disabled}
        >
          <Heart className="h-6 w-6 text-green-500" />
        </Button>
      </motion.div>
    </div>
  );
};
